import AppSelector from '@/agilis/components/AppSelector/AppSelector.vue'
import { mapGetters } from 'vuex'
import Maintenance from '@/agilis/components/Maintenance/Maintenance.vue'
import SplashScreen from '@/agilis/mobile/SplashScreen/SplashScreen.vue'

export default {
  name: 'Home',

  components: {
    AppSelector,
    Maintenance,
    SplashScreen
  },

  computed: {
    ...mapGetters({
      'showSplash': 'userDataStore/showSplash',
      'applicationMaintenance': 'contextStore/applicationMaintenance',
      'authorizedApplications': 'configurationStore/auth/applications',
      'authorizedWorkspaces': 'configurationStore/auth/workspaces'
    }),

    userHasOneWorkspace () {
      return Object.keys(this.authorizedApplications).length === 1 &&
        Object.keys(this.authorizedWorkspaces[Object.keys(this.authorizedApplications)]).length === 1
    }
  },

  methods: {
    handleClick () {
      this.$store.commit('userDataStore/setShowSplash', false)
      if (this.userHasOneWorkspace) {
        this.$router.agilis.workspace(Object.keys(this.authorizedApplications)[0],
          Object.keys(this.authorizedWorkspaces[Object.keys(this.authorizedApplications)])[0])
      }
    }
  }
}
